import {
    sagaEffects,
    restaurantsActions,
    restaurantsActionTypes,
    restaurantsSelectors,
    antdMessage,
    config,
} from '../dependencies';

import { leftPanelOpenSelector } from './selectors';
import { toggleLeftPanel } from './actions';
import actionTypes from './actionTypes';

function* handleTogglePanel({ payload }) {
    try {
        const panelOpen = yield sagaEffects.select(leftPanelOpenSelector);

        // panel closed
        if (!panelOpen) {
            yield sagaEffects.put(restaurantsActions.saveRestaurantsSettings());
            yield sagaEffects.put(restaurantsActions.checkSelectedRestaurants());
        }
    } catch (e) {
        // TODO: handle errors
    }
}

function* handleLoadRestaurantSettingsCompleted() {
    const restaurants = yield sagaEffects.select(restaurantsSelectors.restaurantsSelector);
    const selectedRestaurants = yield sagaEffects.select(restaurantsSelectors.selectedRestaurantsSelector);

    if (selectedRestaurants.length === 0 && restaurants.length > 0) {
        yield sagaEffects.put(toggleLeftPanel(true));
        antdMessage.info(
            'Vyberte restaurace jejichž jídelní lístky chcete zobrazovat',
            config.infoMessageSecondsDuration * 2,
        );
    }
}

export default function*() {
    yield sagaEffects.all([
        sagaEffects.takeEvery(actionTypes.TOGGLE_LEFT_PANEL, handleTogglePanel),
        sagaEffects.takeEvery(
            restaurantsActionTypes.RESTAURANTS_SETTINGS_LOAD_COMPLETED,
            handleLoadRestaurantSettingsCompleted,
        ),
    ]);
}
